<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-xs-3 col-md-1">
            <center>
              <i style="font-size: 300%; color: grey" class="fa fa-file"></i>
            </center>
            <br />
          </div>
          <div class="col-xs-9 col-md-11">
            <p class="title-card">
              <strong style="color: grey">Gestión de terapias</strong>
              <br />
              <small
                >Administra la información de las terapias, podras cancelar el
                registro.</small
              >
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <br />
        <div class="col-md-5">
          <label for="">Selecciona el paciente</label>
          <select
            name=""
            class="form-control"
            v-model="pacienteSelected"
            placeholder="Selecciona el paciente..."
          >
            <option value="" selected>Seleccionar el paciente...</option>
            <option
              v-for="paciente in pacientes"
              :key="paciente.PacIdeUsu"
              :value="paciente.PacIdeUsu"
            >
              {{ paciente.PacNom1 + " " + paciente.PacApe1 }}
            </option>
          </select>
          <!-- <input list="pacientes" v-model="pacienteSelected" class="form-control" placeholder="Busca un paciente..." @change="updateSesions()">
                    <datalist id="pacientes">
                        <option v-for="paciente in pacientes" :key="paciente.PacIdeUsu" :value="paciente.PacIdeUsu">{{ paciente.PacNom1 + ' ' + paciente.PacApe1 }}</option>
                    </datalist> -->
        </div>
        <div class="col-md-5">
          <label for="">En que fecha fue la terapia?</label>
          <input
            type="date"
            :min="fechaValidacion"
            :max="fechaActual"
            v-model="fechaSesion"
            class="form-control"
          />
        </div>
        <div class="col-md-1">
          <label for="" style="color: white">accion</label>
          <button
            class="btn btn-success btn-fill"
            @click="updateSesions()"
            style="border-radius: 7px"
          >
            Buscar
          </button>
        </div>
        <div class="col-md-12">
          <br /><br />
          <div class="card-header">
            <div class="row">
              <div class="col-xs-12 col-md-12">
                <p class="title-card">
                  <strong style="color: grey">Terapias disponibles</strong>
                </p>
              </div>
              <div
                v-for="sesion in sesiones"
                :key="sesion.terapeuta"
                class="col-xs-12 col-md-4"
              >
                <div class="card" style="padding: 20px">
                  <div class="row">
                    <div class="col-md-12">
                      <center>
                        <strong class="text-success">{{
                          sesion.nombrePaciente
                        }}</strong>
                        <!-- <span class="badge text-bg-success">Terapia dispobible para cancelar</span> -->
                      </center>
                      <!-- <hr> -->
                    </div>
                    <br />
                    <div class="col-md-12">
                      <br /><br />
                      <p style="color: grey">
                        <i class="fa fa-calendar"></i>Fecha: {{ sesion.fecha }}
                      </p>
                      <p style="color: grey">
                        <i class="fa fa-clock-o"></i> Hora: {{ sesion.hora }} a
                        {{ sesion.horaFin }}
                      </p>
                      <p style="color: grey">
                        <i class="fa fa-user"></i> Terapeuta:
                        {{ sesion.terapeuta }}
                      </p>
                      <p style="color: grey">
                        <i class="fa fa-hashtag"></i>Cantidad:
                        {{ sesion.cantidad }}
                      </p>
                    </div>
                    <div class="col-md-12">
                      <br /><br />
                      <button
                        @click="cancelarSesion(sesion)"
                        style="border-radius: 7px"
                        class="btn btn-success btn-fill btn-block"
                      >
                        Cancelar registro
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data: () => ({
    ip: "https://avanti-erp.com/",
    pacientes: [],
    pacienteSelected: "",
    fechaSesion: "",
    fechaValidacion: "",
    fechaActual: "",
    sesiones: [],
  }),
  methods: {
    selectPaciente: function () {
      this.$modal.show("carga");
      const BASE_URL = `${this.ip}api/pacientesSelect`;
      axios
        .get(BASE_URL)
        .then((res) => {
          this.pacientes = res.data.data;
          this.$modal.hide("carga");
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },
    updateSesions: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const pacienteSelected = this.pacienteSelected;
      const fechaSesion = this.fechaSesion;
      const BASE_URL = `${this.ip}api/sesionesDisponiblesCancelar/${pacienteSelected}/${fechaSesion}`;
      if (fechaSesion == "" || pacienteSelected == "") {
        alert("Debe seleccionar un paciente y la fecha de la sesion");
        return;
      } else {
        this.$modal.show("carga");
        axios
          .get(BASE_URL, config)
          .then((res) => {
            let sesiones = res.data.data;
            let sesionesMostrar = [];
            const terapeutasSesiones = Object.keys(sesiones);
            for (let index = 0; index < terapeutasSesiones.length; index++) {
              const element = sesiones[terapeutasSesiones[index]];
              let sesion = {
                paciente: element[0].PacIde,
                fecha: element[0].ProFec,
                hora: element[0].hora,
                horaFin: element[0].horaFin,
                terapeuta: element[0].terapeuta,
                autorizacion: element[0].autorizacion,
                cantidad: element.length,
                nombrePaciente: element[0].nombre + " " + element[0].apellido,
              };

              sesionesMostrar.push(sesion);
            }
            this.$modal.hide("carga");
            this.sesiones = sesionesMostrar;
          })
          .catch((err) => {
            this.$modal.hide("carga");
            console.log(err);
          });
      }
    },
    cancelarSesion: function (sesion) {
      this.$modal.show("carga");
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}api/cancelar-sesion`;
      axios
        .post(
          BASE_URL,
          {
            sesion,
            fechaActual: this.fechaActual,
          },
          config
        )
        .then((res) => {
          this.$modal.hide("carga");
          if (res.data.message == "orden vencida") {
            this.$notify({
              component: {
                template: ` <div style="padding: 5%;">
                <p><strong> No se puede cancelar la sesión</strong></p>
                <span> La orden ya está vencida </span>
                </div>
                `,
              },
              icon: "ti-close",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger",
            });

            this.updateSesions();
          } else {
            this.$notify({
              component: {
                template: ` <div style="padding: 5%;">
                <p><strong> Sesión cancelada con éxito</strong></p>
                <span> La sesión fue cancelada </span>
                </div>
                `,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger",
            });
            this.updateSesions();
          }
        })
        .catch((err) => {
          this.$notify({
            component: {
              template: ` <div style="padding: 5%;">
              <p><strong> No se puede cancelar la sesión</strong></p>
              <span> Ocurrió un error en el servidor. </span>
              </div>
              `,
            },
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          console.log(err);
          this.$modal.hide("carga");
        });
    },
    fechamenosdias: function () {
      var fecha = new Date();
      fecha.setDate(fecha.getDate() - 5);
      // console.log("fecha menos 7 días", fecha);

      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }

      return fechaFormateada;
    },

    calcularFechaActual() {
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
  },
  mounted() {
    this.selectPaciente();
    this.fechaValidacion = this.fechamenosdias();
    this.fechaActual = this.calcularFechaActual();
    this.fechaSesion = "";
    this.pacienteSelected = '';
  },
};
</script>
<style lang="css" scoped>
.card-header {
  padding-bottom: 10px !important;
  background-color: #f3f2ee;
  border-radius: 15px !important;
}

.card {
  box-shadow: 0 0 0 0;
  border-radius: 15px;
  padding: 2%;
}

.card-chart {
  box-shadow: 0 0 0 0;
  border-radius: 15px;
  /* padding: 4%; */
  margin: 2px;
  background-color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ADashboard/gestionTerapias.vue